module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/005TOC#chapter_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("R")])]), _vm._v("ebecca finally finished painting the in-law apartment on a Friday night, and on Saturday morning she rented it to some poor guy who had just left a monastery. The ad had not even appeared in the papers yet, but she had tucked a tiny Apt. for Rent sign in the front window and he just wandered by and rang the bell. His name was Michael Christopher.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was a lanky man in his early forties, a little Lincolnesque, with rounded shoulders and a long, sad face muffled by a beard in need of trimming. His hands were too big for his arms and his feet were too big for his legs. His hair was cropped close, the merest new dark stubble on a skull that had obviously been kept shorn until recently. The in-law apartment’s ceiling was low and he kept his head ducked a little, whether from fear of smacking it or out of some deeper humility, Rebecca could not tell. It was her impression that he was in no danger if he wanted to straighten up, so maybe the hunch was meekness. He "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("wore plain black trousers, rather rumpled, a shirt that had once been white but had yellowed remarkably, a black jacket with the shoulder seam split, and some white, high-top Converse sneakers from the era before athletic shoes made statements. After twenty years of living a monk’s life, he could fit all his other possessions into a comically small black satchel. It looked like a doctor’s bag.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why did you leave the monastery?” she asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged. “I had a fight with my abbot. Among other things.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A fight?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled, a little wearily. “To put it in layman’s terms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca laughed. “Well, that’s not very Christian, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s sort of a long story.” Christopher hesitated. “I was fed up with that place anyway, to tell you the truth. I had prayed myself into a hole.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The evidence of hotheadedness, along with his frankness, was strangely reassuring. She liked his smile and his unguarded brown eyes. He had no credit history at all, of course. He didn’t even have a driver’s license. He had a check, some kind of severance pay—did contemplatives get severance pay?—that he hadn’t been able to get cashed. He had no job as yet. As far as she could determine he had no prospects, no plan, and no résumé. But there was something about him that she liked a lot, a gloomy depth. And there was the appeal of the quixotic. He had devoted his adult life to the contemplation of God. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That")]), _vm._v(" was his résumé. He had done what she had always intended to do with her own life and flung it into the maw of Meaning in one grand, futile gesture, and he had nothing to show for it but the clothes on his back. He’d been sleeping in the park and he hadn’t eaten in three days, but he seemed unperturbed by that. It was all very New Testament.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The apartment showed fast. A bathroom, a minute, stoveless kitchen with a half-fridge on one counter and a hot plate on the other, and the single real room in the place, an 8 x 15 box carpeted in a brown that had not seemed so dishearteningly the color of mud in the samples. The walls, at least, were a fresh cream. Rebecca was proud of her paint job.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The room’s lone window opened into the barren backyard. Christopher went right to the glass and stood looking out at the weedy waste. Rebecca could feel his melancholy. It was not much of a prospect.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I keep meaning to put in a garden back there,” she said. “Or something. But there’s never any time, it seems. And when there’s time, I just want to recover.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d be glad to do some work back there myself. It’s a nice space.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, well—” Rebecca murmured, flustered, assuming he was angling to reduce the rent through work exchange. “If I could afford a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gardener")]), _vm._v("…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His look was genuinely uncomprehending; it had not occurred to him to charge her. Well, that was very New Testament too, of course. But mortgages were Old Testament, and hers was about to balloon. She had been hoping to rent the apartment to a quiet spinster with an obvious income, not a down-and-out man of God.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("As they stood there, she clearly heard his stomach growl. Their eyes met. His look was apologetic, with a trace of dry amusement; he had lovely warm brown eyes. Rebecca took him upstairs, gave him a bowl of Cheerios, and introduced him to her daughter. At six years old, Mary Martha was an infallible detector of bullshit. Christopher was immediately easy with the child in an unflamboyant way. So many adults just turned up the volume, as if a kid couldn’t hear. But Christopher got ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("quietly attentive, like a shy child himself. The two of them sat at the kitchen table with their twin bowls of cereal and studied the back of the box together. Mary Martha soon was chattering away, and when she invited Christopher to see her unicorns, Rebecca took it as a sign and let him have the apartment.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was tempted to renege the next day. The deluge of applicants responding to the newspaper ad included a number of solid citizens. But by then she had cashed his monastery check for him and accepted first and last in cash, and he was settled in. And Rebecca had to admit that Christopher’s delight in the in-law apartment was charming. She’d never seen a man so grateful for a shower, a hot plate, and a half-fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To Br. James Donovan")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("c/o Our Lady of Bethany Monastery")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mendocino County, CA")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dear Brother James,")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thank you for your letter, and for your very touching concern. I have indeed “settled nicely” into a situation here in the city, as you hoped. The details you request are not that important. Suffice it to say that I am content. (I must ask, incidentally, that you not address me any longer as “Brother Jerome.” I am Michael Christopher now. Again…The name seems strangely like an alias after twenty years. But that is all the more reason to insist on using it. My identity itself has become a kind of hair shirt.)")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Forgive me if I say that I am not sure what purpose would be served by “continuing our conversation in faith,” as you put it. You are ")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("young, and eager, and were struck upon your arrival at Our Lady of Bethany by something in me that you took for depth. I was a seasoned monk, you thought, with an inner life rich in God. You took me for a model of sorts, and I confess that I was flattered. But surely my “depth” has revealed itself by this time as a side effect of less appealing qualities; the “richness” of my inner life is a complexity more riddled with doubt than illumined by faith.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It is true that our conversations in the past were delightful. I cherished the gift of your friendship from the moment you came to Our Lady of Bethany. Your fresh eye, your intelligence, and the purity of your commitment to the contemplative life were a joy to me, and sparked a renewal of my spirit. But paradoxically enough, it was in trying to convey to you something of my own love for the contemplative life that I came to realize how desperately little I had to show for twenty years of prayer. It became a kind of torment to me, to see your innocent eagerness. I realized that something in me was saying, was fairly shouting,")]), _vm._v(" Go back! Go back to the world! It is not too late for you to avoid becoming what I have become.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And what have I become? You ask what prayer is for me now. I used to have so many lovely answers. Prayer is communion, adoration, praise; it is the practice of the presence of God. Prayer is abiding in love. I had a catalogue of ready definitions through the whole of my novitiate, all substantial and high sounding, an impressive array. But all that holy busyness seems like a kind of sand-castle building to me now, and the zeal of my answers is a heap of soggy kelp left by the tide. There is a prayer that is simply seeing through yourself, seeing your own nothingness, the emptiness impervious to self-assertion. A prayer that is the end of the rope. A helplessness, fathomless and terrifying. No matter how holy or well meaning you were when you started out, no matter how many fine experiences you had along the way, by the time you reach the point of this prayer, you want only to get out of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And God? God is that which will not let you out of it.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do you see my point? I am a ruined man. Your kindness at this point only pains me, and forces a fresh consciousness of my failure. Certainly there is nothing to be gained by your “following my secular career,” as you so cheerfully put it. I anticipate no secular career. More than ever, I am certain that I am in God’s hands, that my life is paper to His fire. If I am sometimes inclined to feel now, with Jeremiah,")]), _vm._v(" He hath led me, and brought me into darkness, but not into light, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that has more to do with my own temptation to bitterness than with your religious vocation. My seemingly endless squabbles with Abbot Hackley and with the creeping staleness of monastic routine are ancient history: It is with my bitterness and my sense of failure that I must struggle now; it is to this that God has led me. That cannot possibly be edifying to you; and certainly I would prefer to endure my humiliations in private.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Forgive me if I have put this too harshly. But believe me when I say that I’m doing you a favor. I am at best a cautionary tale; I am some shattered glass and metal rimmed with flares on the road to God. Drive on quietly, Brother James, and don’t look back.")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yours in Christ (as you say),")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Christopher")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he Friday after Rebecca rented the in-law apartment to Michael Christopher, Bob Schofield proposed. Rebecca was startled but not truly surprised. She had seen his delusion building for months, but she had been ignoring it, hoping it would go away. Bob was earnest beyond her comprehension, impervious to her slights and neglects, as ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("uninsultable as a tank. He simply took every nonrefusal on her part, every concession to see a movie or let him buy her a meal or a drink, and worked it patiently into the scheme of their Relationship, as he had called it from the start. She knew that he was serious. She had been to his apartment, she had seen the shelf of books devoted to Relationship. The project had a paint-by-numbers quality to it, but there was no denying the way Bob laid the color on. Apparently Rebecca’s utter lack of enthusiasm was not a problem for him.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had held out hopes, in the beginning, for a harmless friendship. For companionship, a simple muffling of the loneliness of single motherhood. She had even toyed, early in the relationship, with the unnerving inkling that she might…not come to love Bob, but perhaps in time to resign herself to him. That such a resignation might be the lost key to her deferred adulthood, some yet-unprayed penance for her misspent youth. Maybe grown-up-ness hinged upon the exhaustion of passion into affectionate benignity. Maybe that was how they did it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Bob had taken her and Mary Martha to his church one Sunday during this unnerving phase. Despite his bright pop notions of Relationship, he was an Episcopalian, which seemed to Rebecca at once admirably substantial and safely dilute, a sort of Catholicism Lite, without the high guilt content and devotional ferocity of the Church of her childhood. The mass, which Bob called a service, echoed with eerie near precision the liturgy she had grown up on, and she couldn’t help chiming in from time to time from struck chords of memory, only to find herself a word or two off in the Anglican version or praying on when everyone else had ceased or ceasing while the rest of the congregation prayed on. She knelt instinctively at the consecration, out of old Catholic reflex, and Mary Martha, who had never ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("been in a church before, knelt unhesitatingly beside her. Everyone else had remained standing. Perhaps it was the touching faith of Mary Martha following her example against the grain; or perhaps it was simply some deep-seated orneriness or a residual bit of Catholic team spirit, a contempt for the humanistic Protestants’ unwillingness to bend their knees; or maybe it was just the sharpness of the emptiness that the posture brought home, the piercing sense of kneeling before a mystery too alien by now for proper worship. In any case, Rebecca remained on her knees, stubbornly, even defiantly, and rose only for the Our Father, which she treated as concluded after “and deliver us from evil,” leaving the Episcopalians to finish out the longer Protestant version on their own and to say “Ah-men.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The awkwardness culminated at communion. Bob insisted to the verge of public embarrassment that Rebecca accompany him up the aisle. He seemed to think it would be crucially good for her. She followed him up and knelt resignedly beside him at the polished cherrywood rail, feeling blatant, a fraud, and half anticipating some sudden blaring of an alarm sensitive to the presence of religious impostors. The priest approached and held up the Host, saying, “The Body of Christ—” and Rebecca said “Ay-men,” conscious of her Catholic accent, and stuck out her tongue to receive the wafer, according to the training of her childhood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“—the bread of heaven,” the priest concluded, with a mild note of having been preempted. He wavered, host in hand, apparently baffled by her protruding tongue. There was an awkward pause. Beside her, Bob was miming broadly with cupped hands, and after a bad moment Rebecca recovered and shaped her own hands likewise to receive the blessed wafer. The priest dropped one in Bob’s palm too and hurried on, clearly eager for smoother exchanges.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bob consumed his bit of bread with a suitably reverent air. Following his example, Rebecca moved to eat her own Host, but she caught herself with the wafer halfway to her mouth, overcome by a sudden intimation of sacrilege. How could she possibly just pop the Body of Christ into her mouth like an hors d’oeuvre at a church picnic, after all these years, these literal decades of laxity, if not actual sin? She hadn’t even prayed, “Lord, I am not worthy to receive You…” These blithe Episcopalians left that out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A deacon was approaching with a chalice, stooping to give the woman beside Rebecca a sip of the wine, intoning, “The Blood of Christ, the cup of salvation—” Before he could move on to her, Rebecca rose abruptly, charged with a violent certainty that she was not ready, not ready at all for the cup of salvation, for the blood of the Lamb.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bob gave her a startled glance, then actually reached for her arm. Apparently he believed that she was simply unclear on the procedure. Rebecca dodged him easily and fled, shouldering through the muddle of approaching communicants. She hurried down the central aisle, out the door at the back of the church, and into the parking lot, where she finally came to an uncertain halt. She couldn’t remember what Bob’s car looked like. There were so many silvery luxury cars in the crowded lot that it looked like a Mercedes auto fair.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("She was still clutching the communion wafer in her hand. It felt weirdly hot against her palm, a point of fire like a needle or a nail. A stigmata of ambivalence, she thought ruefully. The spring morning was warm and incongruously beautiful; somehow the usual San Francisco fog would have suited her better. She was remembering the day she had ceased to believe in a God who could punish her. She had been sixteen, capable at last of driving to church herself, and she had talked her ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("mother into letting her take the family’s second car, a dumpy Ford Pinto, the model that was later determined to be an explosion waiting to happen because of the placement of the gas tank. Instead of going to mass, though, she had bought two Krispy Kreme jelly doughnuts and a large coffee and driven out to the beach. She’d eaten the doughnuts as a condemned inmate might eat his last meal, fairly sure that the Lord would strike her down for bailing so calculatedly on church.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But nothing had happened, an awesome nothing. She had finished the doughnuts and licked her fingers and sipped her coffee. The waves had broken on the gray New Jersey sand and the gulls had careened and shreed. It had just been a lovely sunny day like this one. She’d felt, somehow, that God had let her down. The least He could have done was shown some interest in her sacrilege. A rear-ender, maybe, the Pinto smacked from behind by the hand of a vengeful Lord, square on the misplaced gas tank. A fireball. That’ll teach you to skip mass. Nothing fatal; an attention grabber merely. She could have emerged from the purgative flames scorched but chastened, seared into unassailable belief.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mary Martha popped out of the church now with her tiny legs pumping hard, squinting in the sunlight, containing tears. Spotting Rebecca, she started toward her at once, already beginning to cry. Bob, a step behind her, was struggling comically to hide his embarrassment and chagrin, to arrange his face in a way that facilitated Relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The communion wafer had turned to a lump of soggy bread in Rebecca’s clenched hand. But she didn’t know what to do with it. You couldn’t just toss the body of Christ aside in a parking lot for the pigeons to eat. As Mary Martha and Bob strode toward her, forcing the issue, she licked her palm surreptitiously and swallowed, and the bread stuck in her throat.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the car on the way home, listening to Mary Martha sniffle, Rebecca began to cry too, to her own dismay. Bob, disconcerted, stammered for a while and finally stopped, a little desperately, at Dairy Queen, where he bought all three of them vanilla ice cream cones with colored sprinkles. It was so sweet and touching that Rebecca was afraid for a while that she might have to marry him, that it was a message from God after all, the perfect humiliation. But she’d come back to her senses soon enough. Bob had kept the Dairy Queen receipt. She didn’t even ask him why. It didn’t really matter. She couldn’t live with a man who’d found an accounting niche for ice cream cone expenses.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t that Bob was unattractive. There were those who thought him quite good-looking, with every wiry black hair in place and trusting brown waif’s eyes. He was undeniably a nice guy. He was smart, and he could be witty. But his chin was weak, and he had a wispy softness of manner, a breathiness. He would have made a great gay friend, Rebecca had often thought. She treated him, indeed, as she might have treated a gay friend, with a frank, easy camaraderie, as one of the girls. But Bob was straight enough, in his programmatic way. He lingered at the end of their outings, which he insisted on calling dates, allowing the awkward pause at the doorstep to grow ponderous, waiting with painful obviousness for a goodnight kiss. Rebecca had taken to kissing him on the cheek just to deflate the moment’s significance, but recently Bob had begun to try to meet her lips. Their neck dynamics had gotten as intricate as those of fighting cocks. There had been lip contact. How he could possibly have found any of this grist for the mill of Relationship was beyond her. Bob had no pride. Combined with his fundamental obtuseness, this actually made him a little dangerous. Things should never have gone this far.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pulled out the ring at a lovely, ridiculously expensive Italian restaurant in North Beach. On cue, a violin player and a waitress laden with lilies approached the table. Bob got down on one knee. Everyone in the restaurant was watching indulgently, waiting to applaud. It was not possible to explain to them that the drama was entirely Bob’s. Rebecca knew that she had never done anything more encouraging than to shrug off his more flagrant hints: not a single yes had crossed her lips. It had seemed pointless to hurt his feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was thinking of Rory now, inevitably. Rory with his gift for ad lib, who had proposed on the N-Judah train on a Tuesday afternoon. He hadn’t even had a ring—he’d rummaged through his pockets for a token of their enduring love and given her a guitar pick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Say you will make me the happiest man alive,” Bob said from the floor at her feet, his wishful thinking writ large and public. Rebecca looked at him and all she could think was how tiresome it was, and how sad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll talk about it later,” she said. “Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emboldened by the sympathetic crowd, perhaps, he held his ground. “I need an answer now, darling.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had begun to call her “darling” on their third outing, right after the fiasco at the church; she had fought the endearment off until their seventh date. Bob was the only one counting, of course. Rebecca leaned closer and lowered her voice so that only he could hear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get back in your goddamned chair, Bob, right this minute. I am not going to marry you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face fell, but he obeyed. He was good that way, of course; it was his strength. The other patrons applauded uncertainly. The clueless violinist began to play something screechy and romantic. The wine waiter arrived on cue with champagne.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“May I be the first to offer my most sincere congratulations,” he said, laying on the fake Italian accent.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In Bob’s Lexus on the way home, Rebecca lit a cigarette. She allowed herself five Marlboro Lights a day and thought of them as little suicides. There was also a certain amount of frank hostility in the act. Bob had a horror of his car smelling of smoke. She ran the electric window down and let the cold night air blast in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry,” Bob said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So am I, Bob.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I really thought—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know you did. It’s my fault as much as yours. I should have been ruder, sooner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, I think you’ve been rude enough, often enough. I just haven’t wanted to believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca glanced at him appreciatively. She had always wondered if he even noticed. The car radio was leaking something stupefying and symphonic at an anesthetizing volume. Bob had it set to a classical station, as always. He kept the ambiance as orthodox as a dentist’s waiting room. Sometimes he would make jaunty little conductor’s motions with his free hand as he drove. Rebecca took the last drag off her cigarette, the breath most laden with carcinogens, and flipped the butt out the window. Holding the smoke in her lungs, she felt a moment’s compassion for both of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Let me just stay here, she thought. Let me not have to go back into the fray. Let me not have to be unkind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I love you, is the thing,” Bob said. “Call me an incurable romantic, but I have to believe in that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Rebecca let her breath out. The night tore the smoke away. She pressed the button and the window hummed up. She had ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("one cigarette left in her daily allotment of small deaths, and she was determined not to spend it here.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s a movie, Bob. Don’t you see? It’s just a movie, and you’ve miscast the lead. I like you. I admire your…spunk. Your grit, your uncrushable goodwill. I’m not even looking for more than that at this point in my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course you are. Everyone is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. I had the romantic thing with my first husband, thank you very much. I’m thirty-eight years old, and I’ve got a daughter learning to read and a job I don’t quite like. I’ve got a mortgage. I’m making my middle-aged peace with network television. Tomorrow is another day I’ve got to get through. If you could just behave yourself, we could have the occasional movie or meal together and I would feel that much less like a troll and a drudge. But I don’t need the violin music, Bob. I don’t want it. I find it sort of pathetic, really.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bob took this in a silence that had a touch of sulk in it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So we’re back to junior high school,” he said at last. “You ‘just want to be friends.’ I have a great personality. It’s nothing personal. It’s you, not me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would love it if we could do this without regressing completely. But if junior high school works for you—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What works for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you?")]), _vm._v(" What can I do differently? I’m willing to change, Rebecca. I’m willing to grow. I’ll do anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He would, she knew. Rebecca sighed. “If you got any better, Bob, I would die from guilt. Just take me home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They did not speak for the rest of the drive back to the Sunset. Bob pulled up in front of her house on 38th Avenue and put the car in neutral. Pointedly, he did not turn the engine off, and he made no move to get out. Rebecca found that she was grateful for his pique. It made things so much easier.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("“Well, goodnight,” she offered, playing on the inadequacy ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("of it, hoping to share at least the camaraderie of fiasco. But Bob just hunched his shoulders.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Goodnight,” he replied curtly, as obvious as a child. He had both hands on the steering wheel and he would not meet her eyes. He wanted another round of drama; he wanted at least the dignity of a scene. Rebecca shrugged and opened the car door herself, feeling cruel. She got out, closing the door carefully, not wanting to feed his sense of melodrama by slamming it, and walked up the steps to her front door. At least there would be no neck dance tonight, no avoiding or succumbing to deluded kisses.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bob’s tires gave a petulant yelp as he pulled away. Rebecca shook her head, wondering if there would ever be anyone in her life again who slipped between the cartoon predictabilities and the emptiness. She knew she had been trying to fake a friendship as hard as Bob had been trying to fake a romance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Inside, she paid the baby-sitter and sent her home, then went to check on Mary Martha. Her daughter was sleeping soundly. Rebecca resisted the urge to go sit by her bed and gaze at her perfect face. It was enough just to hear her contented breathing. In the darkness, a throng of stuffed animals softened every surface of the bedroom. Mary Martha’s unicorn phase went on and on. Sometimes, watching her at play, seeing the look of absorption on her face as she put her magic animals through their paces, Rebecca would feel a tender ferocity rising in herself, a readiness to battle the world. All she really wanted was to protect her daughter’s joy in unicorns. It was like loving soap bubbles, she knew, treasuring that innocence. Yet nothing else in her life right now moved her in the least. She often thought that must be a little pathetic; surely she should have found a larger cause by this time. But the larger causes of her youth had bled away. Her sense of the Big ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Picture had fractured and decayed. She loved her daughter, the blessing of a good book, a glass of wine after the day’s wave of vanity had passed.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And the occasional cigarette. Was that shallow? Then she was shallow, it seemed. Rebecca closed the bedroom door and slipped down the hallway, moving with the instinctive wariness she still caught herself in now. Five years after the divorce, the house remained dangerous in unforeseeable ways, like a children’s playground riddled with unexploded mines from a previous war. Little bits of Rory surfaced, devastatingly: a bookmark halfway through the collected short stories of Flannery O’Connor, a twenty-dollar bill tucked under the silverware tray for a rainy day, birthday cards he’d bought and never sent. Evidence of promises not kept and promises abandoned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She passed through the kitchen to the back porch. The abalone shell on the top step was filled with butts; she kept meaning to empty it. She sat down, tugged her coat around her, and lit the day’s last Marlboro. Above her, the stars themselves seemed weary in a sky bleached thin by the city’s lights. The dark backyard at the bottom of the stairs communicated neglect. She was really going to have to drag herself out of bed some Saturday and hack back some weeds, at least.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The phone rang inside, and that deep, crazy part of her rose to the sound at once, like a trout to a dry fly. As if it still might be Rory, as if it all might have been a mistake. As if the death of a marriage through a thousand small cuts of violation and neglect could still be healed by the Band-Aid of a single communication.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("But it was Bob, of course. She listened to his voice on the message machine, apologizing already. Apparently he had had time to get home and research the problem in his library of ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Relationship. He had failed to give her her space, he said. He had not been sensitive to her needs. He had “pushed the river.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It went on for a while; he had worked out the lines of a solution too, in excruciating detail. Rebecca stopped listening and took a deep drag on the cigarette. In four good puffs, maybe five, she knew, she would stub the butt into the shell and her life would seem very small and sad to her again. It was the evil magic of nicotine that buoyed this little moment of peace. But it was lovely, nonetheless, to sit quietly, fingering the guitar pick that hung from a silver chain around her neck and listening to the untrimmed bushes rustle in the breeze that blew in from the sea.")])])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page33"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f7a761a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007-chapter01.vue
// module id = 75
// module chunks = 0